import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { finalize, Subject, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { OpfoelgningService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER } from 'src/app/constants';
import { NotificationService } from 'src/app/notifications/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
    selector: 'app-transfer-opfoelgninger-dialog',
    templateUrl: './transfer-opfoelgninger-dialog.component.html',
    styleUrls: ['./transfer-opfoelgninger-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TransferOpfoelgningerDialogComponent implements OnInit {
  form: UntypedFormGroup;
  fromUsers: string[] = [];
  toUsers: string[] = [];
  unknownUser: boolean;
  unsubscribe$ = new Subject<void>();

  get transferFrom() {
    return this.form.get('transferFrom');
  }

  get transferTo() {
    return this.form.get('transferTo');
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private opfoelgningService: OpfoelgningService,
    private loader: LoaderService,
    private errorHandler: ErrorHandlerService,
    private auth: AuthService,
    private notification: NotificationService,
    public dialogRef: MatDialogRef<TransferOpfoelgningerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public fromUser: string
  ) {
    this.form = this.formBuilder.group({
      transferFrom: [fromUser, [Validators.required]],
      transferTo: [this.auth.username, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.loader.show();
    this.opfoelgningService
      .getUsers({ caller: EGIS_SERVICE_CALLER })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe(
        (users: string[]) => {
          this.fromUsers = users.filter((user) => user != this.auth.username);
          this.toUsers = users;
          if (!users.some((x) => x == this.auth.username)) this.toUsers.push(this.auth.username);
          this.toUsers = this.toUsers.sort((a, b) => (a > b ? 1 : -1));
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );

    this.transferTo.valueChanges.pipe(debounceTime(300), distinctUntilChanged(), takeUntil(this.unsubscribe$)).subscribe((transferTo) => {
      this.unknownUser = !this.toUsers.some((x) => x == transferTo);
    });
  }

  transfer() {
    this.loader.show();
    this.opfoelgningService
      .transferOpfoelgninger({
        caller: EGIS_SERVICE_CALLER,
        body: {
          fromUser: this.transferFrom.value,
          toUser: this.transferTo.value,
        },
      })
      .pipe(
        takeUntil(this.unsubscribe$),
        finalize(() => {
          this.loader.hide();
        })
      )
      .subscribe(
        () => {
          this.notification.success('Opfølgningerne er flyttet.');
          this.dialogRef.close();
        },
        (error) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  cancel() {
    this.dialogRef.close();
  }
}
